import { Tab, TabList, Tabs } from "@relex-solutions/fragments"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router"
import { useAuthorization } from "@/shared/hooks/useAuthorization"
import type { NavigationItem } from "./GlobalNavigation.types"

export function GlobalNavigation() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const { hasAccessToCustomers } = useAuthorization()

  const currentTab = `/${location.pathname.split("/")[1]}`

  const navigationItems: NavigationItem[] = [
    {
      value: "/home",
      label: t("globalNavigation.home")
    }
  ]

  if (hasAccessToCustomers) {
    navigationItems.push({
      value: "/customers",
      label: t("globalNavigation.customers")
    })
  }

  const handleNavigationChange = (newTab: string | false) => {
    if (newTab) {
      void navigate(newTab)
    }
  }

  return (
    <Tabs value={currentTab} data-testid="global-navigation">
      <TabList>
        {navigationItems.map((item, index) => (
          <Tab
            key={item.value}
            value={item.value}
            style={{
              paddingLeft: index === 0 ? "var(--fr-size-8)" : "0"
            }}
            onClick={() => {
              handleNavigationChange(item.value)
            }}
          >
            {item.label}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  )
}
